import React, { useState } from 'react';
import { Box, Typography, CircularProgress, useTheme, ToggleButtonGroup, ToggleButton } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import { useRevenueTrends } from '../../hooks/useSubscriptions';

const RevenueTrendChart = ({ year = 'all', month = 'all' }) => {
    const theme = useTheme();
    const { data: trendData, isLoading, error } = useRevenueTrends({ year, month });
    const isDark = theme.palette.mode === 'dark';

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={350}>
                <CircularProgress />
            </Box>
        );
    }

    if (error || !trendData?.data) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={350}>
                <Typography color="error">Failed to load revenue trends</Typography>
            </Box>
        );
    }

    const series = [
        {
            name: 'Revenue',
            data: trendData.data.map(item => item.revenue)
        }
    ];

    const options = {
        chart: {
            type: 'line',
            height: 350,
            toolbar: { show: false },
            background: 'transparent'
        },
        stroke: {
            curve: 'smooth',
            width: 3
        },
        xaxis: {
            categories: trendData.data.map(item => item.date),
            labels: {
                style: { colors: theme.palette.text.secondary }
            }
        },
        yaxis: {
            labels: {
                formatter: (val) => `$${val.toFixed(0)}`,
                style: { colors: theme.palette.text.secondary }
            }
        },
        colors: [theme.palette.primary.main],
        tooltip: {
            theme: isDark ? 'dark' : 'light',
            y: {
                formatter: (val) => `$${val.toFixed(2)}`
            }
        },
        grid: {
            borderColor: theme.palette.divider
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <ReactApexChart options={options} series={series} type="line" height={300} />
        </Box>
    );
};

export default RevenueTrendChart;
